// in src/MyLoginPage.js
import * as React from 'react';
import { useState } from 'react';
import { useLogin, useNotify } from 'react-admin';
import { Button } from '@mui/material';

import Avatar from '@mui/material/Avatar';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';


const LoginPage = () => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const login = useLogin();
  const notify = useNotify();

  const handleSubmit = e => {
    e.preventDefault();
    // will call authProvider.login({ username, password })
    login({ username, password }).catch(() =>
      notify('Invalid username or password')
    );
  };


  return (
    <Grid container direction="column" alignItems="center"
      sx={{
        pt: 8,
        height: '100vh',
        // backgroundColor: 'rgba(54, 65, 75, 1)',
        // backgroundImage: 'linear-gradient(to bottom, rgba(54, 65, 75, 0) 0%, rgba(39, 32, 24, 0.7) 80%), linear-gradient(to right, rgba(54, 65, 75, 1) 10%, rgba(124, 106, 89, 1) 95%)',
        // backgroundRepeat: 'no-repeat, no-repeat',
        // backgroundPosition: 'left top, center',
        // backgroundAttachment: 'fixed, fixed',
        // backgroundSize: 'cover, cover'
      }}
    >
      <CssBaseline />

      <Grid >
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: 'rgba(0,0,0,.2)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <Box
            sx={{
              // border: '1px dashed grey',
              height: '10vh',
              width: '60vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5" sx={{
              color: 'white'
            }}>
              DVET ADMIN
            </Typography>
          </Box>

          <Box component="form" noValidate onSubmit={handleSubmit} sx={{
            // border: '1px dashed grey',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <TextField
              margin="normal"
              required
              style={{ width: 500 }}
              id="username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              name="username"
              autoComplete="username"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon sx={{ color: 'white' }} />
                  </InputAdornment>
                ),
              }}
              autoFocus
              sx={{
                input: { color: 'white' },
                px: 2
              }}
            />
            <TextField
              margin="normal"
              style={{ width: 500 }}
              required
              name="password"
              type="password"
              id="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon sx={{ color: 'white' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                input: { color: 'white' },
                px: 2
              }}
            />
            <Button
              type="submit"
              style={{ width: 500 }}

              variant="contained"
              onClick={handleSubmit}
              sx={{ mt: 3, mb: 2, pl: 5, pr: 5 }}
            >
              Connexion
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>

  );




}

export default LoginPage;